module.exports = __webpack_public_path__ + "static/media/TIAC.fbff7a90.png";